document.addEventListener('DOMContentLoaded', function(event) {
  // Toggle mobile side navigation
  const toggleButton = document.querySelector('button[data-action="toggle-side-nav"]');
  if (toggleButton) {
    toggleButton.addEventListener('click', function() {
      document.body.classList.toggle('side-nav-mobile-expanded');
    });
  }

  // Close side nav when clicking outside of it
  document.addEventListener('click', function(event) {
    const sideNav = document.querySelector('.side-nav');
    if (sideNav && !sideNav.contains(event.target) && !toggleButton.contains(event.target)) {
      document.body.classList.remove('side-nav-mobile-expanded');
    }
  });
});
